import apiClient from "../../../utils/clients/axios";

export const MaterialOutwardMutation = async (payload) => {
  const res = await apiClient.post("/materialoutward/", payload);

  return res;
};

export const MaterialReturnMutation = async (payload) => {
  const res = await apiClient.post("returnablematerials/", payload);

  return res;
};
